import UserClientData from "../../../core/client-data/user/user"
import ProjectLocalSettings from "../project/project-local-setting"
import ViewTemplate from "./view-template"
import ProjectCollectionLocalSettings from "../project-collection/project-collection-local-settings"
import defaultTableSettings from "../../gd-modules/table/manager/settings/default-settings"
import {ViewType} from "../../gd/const/views/view-type"
import {PORTFOLIO_SUMMARY_DEFAULT_SETTINGS} from "../../../app/portfolio/summary/manager/settings/default-settings"
import {PROJECT_PAGE_DEFAULT_SETTINGS} from "../../../app/project/page/settings/default-settings"
import {Workload_DefaultSettings} from "../../gd-modules/workload/manager/default-settings";
import {GANTT_DEFAULT_SETTINGS} from "../../gd-modules/gantt-chart/manager/default-settings";
// const debug = "ViewTemplates"
const debug = false

/*
this.viewTemplates = [
{
        id: template_id1,
        name: template_name1,
        viewSystemType: view_system_type_1,
        access: 'private',
        userId: some_user_id,
        appSettings: {...}
        isDefault: true
},
{
        id: template_id2,
        name: template_name2,
        viewSystemType: view_system_type_2,
        access: 'public',
        userId: some_user_id,
        appSettings: {...}
    }, ...]
*/

/*
RIGHT NOW WE SUPPORT VIEW TEMPLATES FOR:
- task list
- task table
- board
- calendar
- gantt
- workload

- projects table
... enything else ?
 */

export default class ViewTemplates {

    public viewTemplates : ViewTemplate[] = []

    public viewTypes = [
        ViewType.PROJECT_LIST,
        ViewType.PROJECT_TABLE,
        ViewType.PROJECT_BOARD,
        ViewType.PROJECT_CALENDAR,
        ViewType.PROJECT_GANTT,
        ViewType.PROJECT_WORKLOAD,
        ViewType.PROJECT_DOCS,
        ViewType.PROJECT_PAGE,

        ViewType.CUSTOM_VIEW_TASKS_TABLE,
        ViewType.CUSTOM_VIEW_PROJECTS_TABLE,

        ViewType.PORTFOLIO_SUMMARY,
    ]

    constructor() {
        // retrieve company view templates (private)
        const { clientData } = gd.session.me;
        const userTemplates = clientData.viewTemplates ? clientData.viewTemplates : [];

        const allTemplatesConfig = _.union(
            gd.company.settings.viewTemplates,
            userTemplates
        );

        this.viewTemplates = []
        _.forEach(allTemplatesConfig, (viewTemplateConfig)=>{
            const viewTemplate = new ViewTemplate(viewTemplateConfig)
            this.viewTemplates.push(viewTemplate)
        })

        this._normalizeDefaultTemplates()
    }

    _normalizeDefaultTemplates() {
        // this creates default templates if they were not created before (!)

        const createDefaultTemplate = (viewType:ViewType, appSettings:any) => new ViewTemplate({
            id              : '_default',
            viewSystemType  : viewType,
            access          : "public",
            appSettings     : appSettings,
            name            : "Default",
            isDefault       : true
        })

        this.viewTypes.map(viewTemplateSystemType => {
            let defaultViewTemplate = this.getDefault(viewTemplateSystemType)
            if (!defaultViewTemplate) {
                switch (viewTemplateSystemType) {
                    case ViewType.PROJECT_LIST:
                        this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_LIST,require('core/gd-modules/task-list/manager/default-settings').default))
                        break

                    case ViewType.PROJECT_TABLE                 :
                        this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_TABLE, defaultTableSettings))
                        break

                    case ViewType.PROJECT_BOARD                 : this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_BOARD,                 require('../../../core/gd-modules/board/manager/default-settings').default)); break;
                    case ViewType.PROJECT_GANTT                 :
                        // this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_GANTT,                 require('../../../core/gd-modules/gantt-chart/manager/default-settings').default));
                        this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_GANTT, GANTT_DEFAULT_SETTINGS));
                        break;
                    case ViewType.PROJECT_CALENDAR              : this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_CALENDAR,              require('../../../core/gd-modules/events/manager/default-settings').default)); break;
                    case ViewType.PROJECT_WORKLOAD              :
                        // this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_WORKLOAD,              require('../../../core/gd-modules/workload/manager/default-settings').default));
                        this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_WORKLOAD,Workload_DefaultSettings));
                        break;

                    case ViewType.PROJECT_DOCS                  : this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_DOCS,                  require('../../../core/gd-modules/documents/manager/default-settings').default)); break;
                    case ViewType.CUSTOM_VIEW_PROJECTS_TABLE    : this.viewTemplates.push(createDefaultTemplate(ViewType.CUSTOM_VIEW_PROJECTS_TABLE,    require('../../../views/projects-all/manager/default-settings').default)); break;
                    case ViewType.CUSTOM_VIEW_TASKS_TABLE       : this.viewTemplates.push(createDefaultTemplate(ViewType.CUSTOM_VIEW_TASKS_TABLE,       require('../../../views/table/manager/default-settings').default)); break;

                    case ViewType.PORTFOLIO_SUMMARY:
                        this.viewTemplates.push(createDefaultTemplate(ViewType.PORTFOLIO_SUMMARY, PORTFOLIO_SUMMARY_DEFAULT_SETTINGS))
                        break

                    case ViewType.PROJECT_PAGE                 :
                        this.viewTemplates.push(createDefaultTemplate(ViewType.PROJECT_PAGE, PROJECT_PAGE_DEFAULT_SETTINGS))
                        break

                    default:
                        console.warn(viewTemplateSystemType, "missign default template")
                }
            }
        })
    }

    getDefault(systemType:ViewType) {
        // return degfault template for systemType
        return _.find(this.viewTemplates, template=>{
            return template.viewSystemType === systemType && template.isDefault
        })
    }

    getTemplate(systemType:ViewType, templateId:ID) {

        debug && console.log(debug, "getTemplate", systemType, templateId, this.viewTemplates)

        let searchSystemType : any
        switch (systemType) {
            case ViewType.CUSTOM_VIEW_TASKS_TABLE:
                searchSystemType = ViewType.PROJECT_TABLE;
                // CUSTOM_VIEW_TASKS_TABLE has only custom default template, but shares all TASK_TABLE templates
                break

            default:
                searchSystemType = systemType
        }

        let template = _.find(this.viewTemplates, template=>{
            return template.viewSystemType === searchSystemType && template.id === templateId
        })

        if (!template) template = this.getDefault(systemType)

        return template
    }

    getViewTemplates(viewSystemType:ViewType) {
        return _.chain(this.viewTemplates)
            .filter(template=>
                template.viewSystemType === viewSystemType &&
                (template.access === 'public' || template.userId === gd.session.me.id))
            .orderBy([template=>template.isDefault ? 0 : 1, template=>template.name], ['asc', 'asc'])
            .value();
    }

    addTemplate(name:string, access:string, systemType: ViewType, appSettings:any) {
        const newTemplate = new ViewTemplate({
            id              : this._generateViewId(),
            name            : name,
            viewSystemType  : systemType,
            access          : access,
            userId          : gd.session.me.id,
            appSettings     : appSettings
        })

        this.viewTemplates.push(newTemplate);

        this._save();

        return newTemplate;
    }

    addTemplateFromProjectView(name:string, access:string, view:any) {
        debug && console.log(debug, "addTemplateFromProjectView()")

        let projectLocalSettings, appSettings;

        // if we save current view as template the we need to check if appSettings
        // in project local settings were overridden
        const isCurrentView = gd.projectViews.currentView.id === view.id;
        if (isCurrentView) {
            // check base view local settings nad retrieve appSettings
            projectLocalSettings = new ProjectLocalSettings(view.projectId);
            appSettings = projectLocalSettings.views[view.id] ? projectLocalSettings.views[view.id].appSettings : null;
        }

        // if no appSettings were set (from local settings) then set baseView appSettings
        if (!appSettings) appSettings = view.appSettings
        appSettings = _.omit(appSettings, 'templateId');

        return this.addTemplate(name, access, view.systemType, appSettings);
    }

    addTemplateFromProjectCollectionView(name:string, access:string, view:any) {
        debug && console.log(debug, "addTemplateFromProjectCollectionView")

        let projectCollectionLocalSettings, appSettings;

        // if we save current view as template then we need to check if appSettings
        // in project local settings were overridden
        const isCurrentView = gd.projectCollectionViews.currentView?.id === view.id;
        if (isCurrentView) {
            // check base view local settings nad retrieve appSettings
            projectCollectionLocalSettings = new ProjectCollectionLocalSettings(view.projectCollectionId);
            appSettings = projectCollectionLocalSettings.views[view.id] ? projectCollectionLocalSettings.views[view.id].appSettings : null;
        }

        // if no appSettings were set (from local settings) then set baseView appSettings
        if (!appSettings) appSettings = view.appSettings
        appSettings = _.omit(appSettings, 'templateId');

        return this.addTemplate(name, access, ViewTemplates.getTemplateSystemType(view.systemType), appSettings);
    }

    editTemplate(templateId:ID, name:string|null, access:string|null, viewSystemType: ViewType, appSettings:any) {
        const template : any = _.remove(this.viewTemplates, template => template.viewSystemType === viewSystemType && template.id === templateId)[0];
        if (name)           template.name = name;
        if (access)         template.access = access;
        if (appSettings)    template.appSettings = appSettings;

        this.viewTemplates.push(template);

        this._save();

        return template;
    }

    editTemplateFromProjectView(templateId:ID, name:string|null, access:string|null, view:any) {
        debug && console.log(debug, "editTemplateFromProjectView()")

        let projectLocalSettings, appSettings;

        // if we save current view as template the we need to check if appSettings
        // in project local settings were overridden
        const isCurrentView = gd.projectViews.currentView.id === view.id;
        if (isCurrentView) {
            // check base view local settings nad retrieve appSettings
            projectLocalSettings = new ProjectLocalSettings(view.projectId);
            appSettings = projectLocalSettings.views[view.id] ? projectLocalSettings.views[view.id].appSettings : null;
        }

        // if no appSettings were set (from local settings) then set baseView appSettings
        if (!appSettings) appSettings = view.appSettings
        appSettings = _.omit(appSettings, 'templateId');

        return this.editTemplate(templateId, name, access, view.systemType, appSettings);
    }

    editTemplateFromProjectCollectionView(templateId:ID, name:string|null, access:string|null, view:any) {
        debug && console.log(debug, "editTemplateFromProjectCollectionView", view)

        let projectCollectionLocalSettings, appSettings

        // if we save current view as template then we need to check if appSettings
        // in project collection local settings were overridden
        const isCurrentView = gd.projectCollectionViews.currentView?.id === view.id
        if (isCurrentView) {
            // check base view local settings nad retrieve appSettings
            projectCollectionLocalSettings = new ProjectCollectionLocalSettings(view.projectCollectionId)
            appSettings = projectCollectionLocalSettings.views[view.id] ? projectCollectionLocalSettings.views[view.id].appSettings : null

            debug && console.log(debug, "editTemplateFromProjectCollectionView [B]", appSettings, projectCollectionLocalSettings.views[view.id])
        }

        // if no appSettings were set (from local settings) then set baseView appSettings
        if (!appSettings) appSettings = view.appSettings
        appSettings = _.omit(appSettings, 'templateId')

        return this.editTemplate(templateId, name, access, ViewTemplates.getTemplateSystemType(view.systemType), appSettings)
    }

    removeTemplate(templateId:ID) {
        _.remove(this.viewTemplates, template => template.id === templateId);

        this._save();
    }

    _save() {
        debug && console.log(debug, "_save()")

        // save company view templates (public)
        if (gd.ac.check.company.isManager(gd.companyId)) {
            const companyTemplatesConfig : any[] = []

            const companyTemplates = _.filter(this.viewTemplates, template=>template.access === 'public');

            _.map(companyTemplates, companyViewTemplate=>{
                companyTemplatesConfig.push(companyViewTemplate.toJSON())
            })

            gd.company.settings.viewTemplates = companyTemplatesConfig
            gd.company.settings.save();
        }

        //save user view templates (private)
        const { clientData } = gd.session.me;
        clientData.viewTemplates = _.filter(this.viewTemplates, template=>template.access === 'private');
        gd.session.me.clientData = UserClientData.normalize(clientData);

        gd.api.MyAccount.updateClientData({clientData: gd.session.me.clientData});
    }

    _generateViewId() {
        // get existing ids
        const arrayIds = _.map(this.viewTemplates, (view=>view.id));
        // generate
        return gd.utils.generateUIDWithCollisionChecking(arrayIds);
    }

    static getTemplateSystemType = (viewType:ViewType):ViewType => {

        switch (viewType) {
            case ViewType.PORTFOLIO_LIST      : return ViewType.PROJECT_LIST
            case ViewType.PORTFOLIO_TABLE     : return ViewType.PROJECT_TABLE
            case ViewType.PORTFOLIO_BOARD     : return ViewType.PROJECT_BOARD
            case ViewType.PORTFOLIO_GANTT     : return ViewType.PROJECT_GANTT
            case ViewType.PORTFOLIO_CALENDAR  : return ViewType.PROJECT_CALENDAR
            case ViewType.PORTFOLIO_WORKLOAD  : return ViewType.PROJECT_WORKLOAD

            case ViewType.PORTFOLIO_SUMMARY   : return ViewType.PORTFOLIO_SUMMARY
        }

        console.error("How come #3938272 ")

        // @ts-ignore
        return viewType
    }
}